module.exports = __webpack_public_path__ + "static/media/cat-face-svgrepo-com.5cf33e46.svg";